import { IDetailPageData } from "../../../shared/utils/api";

export interface IDomainTypeStage {
  id: string;
  name: string;
  screen_id: string;
  position: number;
  screen_name: string | "";
}

export interface IProcessTypeStageAction{
  id: string;
  action_type: string;
  to_perform: string;
  selected_action_id: string;
}

export interface IProcessTypeStage {
  id: string;
  domain_stage_id: string;
  process_type_id: string;
  process_type_stage_actions: IProcessTypeStageAction[];
  process_type_stage_user_group_ids: string[];
}

export interface IProcessType {
  id: string;
  name: string;
  consolidate_on_entity_id: string;
  consolidate_on_entity_name: string;
  event_capture_screen_id: string;
  event_capture_screen_name: string;
  consolidate_timer: number;
  process_type_id: string;
  process_type_stages: IProcessTypeStage[];
}

export interface IBackendDomainProcessType {
  id: string;
  name: string;
  alertcase_id_prefix: string;
  process_types: IProcessType[];
  stages: IDomainTypeStage[];
}

export function transformToBackendDomainProcessType(data: IDetailPageData): IBackendDomainProcessType {
  return {
    id: data.id || "",
    name: data.name || "",
    alertcase_id_prefix: data.alertcase_id_prefix || "",
    process_types: data.process_types.map((processType: any) => ({ // eslint-disable-line
      id: processType.id,
      name: processType.name,
      consolidate_on_entity_id: processType.consolidate_on_entity_id,
      event_capture_screen_id: processType.event_capture_screen_id,
      consolidation_timeframe: processType.consolidation_timeframe || undefined,
      process_type_id: processType.process_type_id,
      process_type_stages: processType.process_type_stages.map((processTypeStage: any) => ({ // eslint-disable-line
        id: processTypeStage.id,
        domain_stage_id: processTypeStage.domain_stage_id,
        process_type_stage_actions: processTypeStage.process_type_stage_actions.map((action: any) => ({ // eslint-disable-line
          id: action.id,
          action_type: action.action_type,
          selected_action_id: action.selected_action_id
        })),
        process_type_stage_user_group_ids: processTypeStage.process_type_stage_user_group_ids.map((userGroup: any) => ({ // eslint-disable-line
          id: userGroup.id,
          name: userGroup.user_group_name
        }))
      }))
    })),
    stages: data.stages.map((stage: any) => ({ // eslint-disable-line
      name: stage.name,
      screen_id: stage.screen_id,
      position: stage.position
    }))
  };
}

export function transformFromBackendDomainProcessType(backendType: IBackendDomainProcessType): IDetailPageData {
  return {
    rowData: [],
    id: backendType.id || "",
    name: backendType.name || "",
    alertcase_id_prefix: backendType.alertcase_id_prefix || "",
    process_types: backendType.process_types.map((processType: any) => ({ // eslint-disable-line
      id: processType.id,
      name: processType.name,
      consolidate_on_entity_id: processType.consolidate_on_entity_id,
      consolidate_on_entity_name: processType.consolidate_on_entity_name,
      event_capture_screen_id: processType.event_capture_screen_id,
      event_capture_screen_name: processType.event_capture_screen_name,
      consolidation_timeframe: processType.consolidation_timeframe  === null ? undefined : processType.consolidation_timeframe,
      process_type_id: processType.process_type_id,
      process_type_stages: processType.process_type_stages.map((processTypeStage: any) => ({ // eslint-disable-line
        id: processTypeStage.id,
        domain_stage_id: processTypeStage.domain_stage_id,
        domain_stage_name: processTypeStage.domain_stage_name,
        process_type_id: processTypeStage.process_type_id,
        process_type_stage_actions: processTypeStage.process_type_stage_actions.map((action: any) => ({ // eslint-disable-line
          id: action.id,
          action_type: action.action_type,
          selected_action_id: action.selected_action_id,
          to_perform: action.to_perform
        })),
        process_type_stage_user_group_ids: processTypeStage.process_type_stage_user_groups.map((userGroup: any) => ({ // eslint-disable-line
          id: userGroup.user_group_id,
          user_group_name: userGroup.user_group_name,
        }))
      }))
    })),
    stages: backendType.stages.map((stage: any) => ({ // eslint-disable-line
      id: stage.id,
      name: stage.name,
      screen_id: stage.screen_id,
      position: stage.position,
      screen_name: stage.screen_name
    }))
  };
}